module.exports = __webpack_public_path__ + "static/meta-ads-logo-dab8044cccb6f6ea3bd8ebbe7a1e7e42.png";